import inputNumber from './src/input-number.vue'

export default inputNumber
